<template>
  <form @submit.prevent data-vv-scope="voting-form" v-if='vote'>
    <div class="vx-row">
        <div class="vx-col md:w-full w-full mt-5">
        <label>{{ $t('event_new.voter.name') }}:</label>
        <vs-input
            v-model='vote.voting_name'
            class="w-full"
            name="voting_name"
            v-validate="'required'"
        />
        <span class="text-danger">{{ errors.first('voting-form.voting_name') }}</span>
        </div>
        <div class="vx-col md:w-full w-full mt-5">
        <label>{{ $t('event_new.voter.description') }}:</label>
        <vs-input
            v-model='vote.voting_description'
            class="w-full"
            name="voting_description"
            v-validate="'required'"
        />
        <span class="text-danger">{{ errors.first('voting-form.voting_description') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
        <label>{{ $t('event_new.voter.start_date') }}:</label>
        <flat-pickr 
            v-model='vote.voting_start_date'
            :config="configdateTimePicker"
            v-validate="'required'"
            class="w-full"
            name="voting_start_date"
            @on-change="onVotingFromChange"
        />
        <span class="text-danger">{{
            errors.first('voting-form.voting_start_date')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
        <label>{{ $t('event_new.voter.end_date') }}:</label>
        <flat-pickr :config="configdateTimePicker"
            v-model='vote.voting_end_date'
            v-validate="'required'"
            class="w-full"
            name="voting_end_date"
        />
        <span class="text-danger">{{
            errors.first('voting-form.voting_end_date')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
        <label>{{ $t('OpeningMode') }}:</label>
        <vs-select v-model='vote.opening_mode' name="opening_mode" v-validate="'required'" class="w-full select-large">
            <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item,index) in openingMode"
            :error-message="'sasdasdasd'"
            />
        </vs-select>
        <span class="text-danger">{{
            errors.first('voting-form.opening_mode')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
        <label>{{ $t('event_new.voter.type') }}:</label>
				<!-- :id="'voting_'+step" -->
        <vs-select
					v-model='vote.type_of_voting'
					:disabled='isUpdate'
          class="w-full select-large"
        >
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="$t(item.text)"
						v-for="(item,index) in typeOfVoting"
						class="w-full"
						name="type_of_voting"
					/>
        </vs-select>
        <span class="text-danger">{{
            errors.first('voting-form.type_of_voting')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
        <label>{{ $t('event_new.voter.quorum') }}:</label>
        <vs-select v-model='vote.quorum_type' class="w-full select-large">
            <vs-select-item
            :key="index"
            :value="item.value"
            :text="$t(item.text)"
            v-for="(item,index) in typeOfQuorum"
            class="w-full"
            v-validate="'required'"
            name="quorum_type"
            />
        </vs-select>
        <span class="text-danger">{{
            errors.first('voting-form.quorum_type')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
        <label>{{ $t('event_new.voter.secret') }}:</label>
        <vs-select
					v-model='vote.is_secret'
					v-validate="'required'"
					name="is_secret"
					class="w-full select-large"
        >
          <vs-select-item :value="1" :text="$t('Secret')" />
          <vs-select-item :value="0" :text="$t('NonSecret')" />
        </vs-select>

        <span class="text-danger">{{
            errors.first('voting-form.is_secret')
            }}</span>
        </div>
    </div>

    <!-- CANDIDATES -->
    <template v-if="vote.type_of_voting == 1">
        <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-5">
            <label>{{ $t('event_new.voter.number_of_candidates') }}:</label>
            <vs-input-number size="medium"
							v-model='vote.candidate_number'
							name="candidate_number"
							v-validate="'required'"
							:min='1'
            ></vs-input-number>
            <span class="text-danger">{{ errors.first('voting-form.candidate_number') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
            <label>{{ $t('event_new.voter.min_number_of_preferences') }}:</label>
            <vs-select
							name="min_preference_no"
            	v-model='vote.min_preference_no'
            	class="w-full select-large" v-validate="'required'"
            >
            <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in generateOptions(vote.candidate_number)"
            />
            </vs-select>
            <span class="text-danger">{{
                errors.first('voting-form.min_preference_no')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
            <label>{{ $t('event_new.voter.max_number_of_preferences') }}:</label>
            <vs-select
							v-validate="'required'"
              name="preference_no"
							v-model='vote.preference_no'
            	class="w-full select-large"
            >
            <vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item,index) in generateOptions(vote.candidate_number, vote.min_preference_no)"
            />
            </vs-select>
            <span class="text-danger">{{
                errors.first('voting-form.preference_no')
            }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
            <label>{{ $t('event_new.voter.number_of_candidate_elect') }} :</label>
            <vs-input-number size="medium"
							v-model='vote.number_of_candidates_elect'
							name="number_of_candidates_elect"
							v-validate="'required'"
							:min='1' :max='vote.candidate_number'
            ></vs-input-number>
            <span class="text-danger">{{
                errors.first('voting-form.number_of_candidates_elect')
            }}</span>
        </div>
        </div>
        <div class="vx-row">
        <div class="vx-col md:w-full w-full mt-5">
            <h4>Candidate Details</h4>
        </div>
        </div>
        <div class="vx-row" v-for="(candidate,index) in vote.candidates" :key='index'>
          <div class="vx-col md:w-1/6 w-1/6 mt-5">
              <label>Is Button?:</label>
              <vs-switch
                v-model='candidate.is_button'
                class=""
                :name="'candidates['+index+'][is_button]'"
                v-validate="'required'"
              />
              <span class="text-danger">{{
                  errors.first('voting-form.candidates['+index+'][is_button]')
              }}</span>
          </div>
          <div class="vx-col md:w-5/6 w-5/6 mt-5">
              <label>{{ $t('event_new.voter.name_of_candidate') }}:{{ index + 1 }}</label>
              <vs-input
                v-model='candidate.candidate_name'
                class="w-full"
                :name="'candidates['+index+'][candidate_name]'"
                v-validate="'required'"
              />
              <span class="text-danger">{{
                  errors.first('voting-form.candidates['+index+'][candidate_name]')
              }}</span>
          </div>
        </div>
    </template>
    
    <!-- OPTIONS -->
    <template v-if="vote.type_of_voting == 2">
        <div class="vx-row">
        <div class="vx-col md:w-full w-full mt-5">
            <label>{{ $t('event_new.voter.number_of_options') }}:</label>
            <vs-select
              v-validate="'required'"
              name='option_number'
              v-model="vote.option_number"
              class="w-full select-large"
            >
            <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in generateOptions(10,2)"
                class="w-full"
                v-validate="'required'"
                name="option_number"

            />
            </vs-select>
            <span class="text-danger">{{
                errors.first('voting-form.option_number')
            }}</span>
        </div>
        <div class="vx-col md:w-full w-full mt-5">
            <h4>Options</h4>
        </div>
        </div>
        <div class="vx-row" v-for="(option,oidx) in vote.options" :key="oidx">
        <div class="vx-col md:w-full w-full mt-5">
            <label>{{$t('Option')}}:{{ oidx+1 }}</label>
            <vs-input
              v-model="option.option"
              class="w-full"
              :name="'options['+ oidx +'][option]'"
              v-validate="'required'"
            />
            <span class="text-danger">{{
                errors.first('voting-form.options[' + oidx + '][option]')
            }}</span>
        </div>
        </div>
    </template>
    
    <!-- FREE TEXT -->
    <template v-if="vote.type_of_voting == 4">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-5">
              <label>{{ $t('event_new.voter.number_of_candidates') }}:</label>
              <vs-input-number size="medium"
                v-model="vote.candidate_number"
                name="candidate_number"
                v-validate="'required'"
                :min='1'
              ></vs-input-number>
              <span class="text-danger">{{
                  errors.first('voting-form.candidate_number')
              }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
              <label>{{ $t('event_new.voter.min_number_of_preferences') }}:</label>
              <vs-select
                v-model="vote.min_preference_no"
                class="w-full select-large"
                name='min_preference_no'
                v-validate='"required"'
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in generateOptions(vote.candidate_number)"
                  class="w-full"
                />
              </vs-select>
              <span class="text-danger">{{
                  errors.first('voting-form.min_preference_no')
              }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
              <label>{{ $t('event_new.voter.max_number_of_preferences') }}:</label>
              <vs-select
              v-model="vote.preference_no"
              class="w-full select-large"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in generateOptions(vote.candidate_number, vote.min_preference_no)"
                  class="w-full"
                />
              </vs-select>
              <span class="text-danger">{{
                  errors.first('voting-form.preference_no')
              }}</span>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-5">
              <label>{{ $t('event_new.voter.number_of_candidate_elect') }}:</label>
              <vs-input-number size="medium"
                                  v-model="vote.number_of_candidates_elect"
                                  name="number_of_candidates_elect"
                                  v-validate="'required'"
                                  :min='1' :max='vote.candidate_number'
              ></vs-input-number>
              <span class="text-danger">{{
                  errors.first('voting-form.number_of_candidates_elect')
              }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-full w-full mt-5">
              <h4>{{ $t('event_new.voter.candidate_details') }}</h4>
          </div>
        </div>
        <div class="vx-row" v-for="(candidate,index) in vote.candidates" :key="index">
          <div class="vx-col md:w-full w-full mt-5">
              <div class="vx-row">
                <div class="vx-col w-1/8">
                    <label>IsCheckbox: {{ index + 1 }}</label>
                    <vs-switch
                    v-model="candidate.is_checkbox"
                    :name="'candidates['+ index +'][is_checkbox]'"
                    v-validate="'required'"
                    />
                </div>
                <div class="vx-col w-3/8">
                    <label>{{ $t('event_new.voter.name_of_candidate') }}: {{ index + 1 }}</label>
                    <vs-input
                    v-model="candidate.candidate_name"
                    class="w-full"
                    :name="'candidates['+ index +'][candidate_name]'"
                    v-validate="'required'"
                    />
                </div>
                <div class="vx-col w-4/8">
                    <label>{{ $t('event_new.voter.surname_of_candidate') }}: {{ index + 1 }}</label>
                    <vs-input
                    v-model="candidate.candidate_surname"
                    class="w-full"
                    :name="'candidates['+ index +'][candidate_surname]'"
                    v-validate="'required'"
                    />
                </div>
              </div>
              <span class="text-danger">{{
                  errors.first('voting-form.candidates[' + index + '][candidate_surname]')
              }}</span>
          </div>
        </div>
    </template>

    <div class="vx-row">
			<div class="vx-col md:w-1/2 w-full mt-5">
				<label>{{ $t('event_new.voter.voting_duration') }} :</label>
				<timer-countdown :minutes.sync='vote.timer_.minutes' :seconds.sync='vote.timer_.seconds'></timer-countdown>
				<span class="text-danger">
					{{ errors.first('voting-form.timer') }}
				</span>
			</div>
    </div>

	  <slot></slot>
  </form>
</template>

<script>
import TimerCountdown from './../../components/timer-countdown'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { generateOptions } from '@/utils/helper';
import { ValidationObserver } from 'vee-validate';
import { debounce } from  'underscore';

export default {
	name: 'VotingForm',
	components: { flatPickr, TimerCountdown, ValidationObserver },
	data: () => ({
		openingMode: [{text: "Manual", value: "manual"}],
		configdateTimePicker: {
			enableTime: true,
			dateFormat: 'Y-m-d H:i',
			minDate: null,
			maxDate: null,
			altInput: true,
			altFormat: 'F j, Y H:i'
		},
	}),
	props: {
		vote: Object,
		endDate: String,
    validator: { type: Object, default: () => null},
		startDate: String,
		isUpdate: { type: Boolean, default: false}
	},
	computed: {
		typeOfVoting: function() {
			return this.$store.state.event.voting_types.map(p => ({text:p.event_voting_type, value: p.id}))
		},
    typeOfQuorum: function() {
			return this.$store.state.event.quorom_types.map(p => ({text:p.quorum_type, value: p.id}))
		}
	},
	watch: {
    endDate: function(endDate) {
      this.configdateTimePicker.maxDate = endDate;
		},
		startDate: function(startDate) {
      this.configdateTimePicker.minDate = startDate;
		},
    'vote.option_number': debounce(function() {
      this.changeOptionBoxes();
    }, 1000),
		'vote.candidate_number': debounce(function() {
      this.updateCandidateBoxes();
    }, 1000)
	},
  mounted() {
    this.$emit('update:validator', this.$validator);
  },
	methods: {
    generateOptions: generateOptions,
		onVotingFromChange(selectedDates, dateStr) {
      this.$set(this.configdateTimePicker, 'minDate', dateStr)
    },
		updateCandidateBoxes() {
      const difference = +this.vote.candidate_number - this.vote.candidates.length;
      if(difference > 0) {
        for(let i=0; i<difference; i++) {
          this.vote.candidates.push({
            candidate_name: '',
            candidate_surname: '',
            is_checkbox: false,
            is_button: false
          })
        }
      }else if (difference < 0) {
        const idx = this.vote.candidates.findIndex(c => c.candidate_name.trim().length < 1 && c.candidate_surname.trim().length < 1);
        if(idx > -1)
          this.vote.candidates.splice(idx, 1);
        else
          this.vote.candidates.pop();
        this.updateCandidateBoxes(); // recurring until difference is zero
      }
		},
    changeOptionBoxes() {
      const options = [];
      for (var i = 0; i < this.vote.option_number; i++)
      {
        options.push({option:''});
      }
			this.vote.options = options;
    },
	}
}
</script>

<style>

</style>